// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginMasterWrapper {
  background-color: #000;
  width: 100dvw;
  height: 100dvh;
}

.loginWrapper {
  position: relative;
  margin: 0 auto;
  display: flex;
  width: 700px;
  height: 700px;
  justify-content: center;
  align-items: center;
  text-align: center;
}

/* Login Ring Animation */

.loginWrapper i {
  margin-top: 10vh;
  position: absolute;
  inset: 0;
  border: 2px solid transparent;
  border-radius: 50%;
  transition: 0.5s;

  &:hover {
    border: 6px solid var(--clr);
    filter: drop-shadow(0 0 20px var(--clr));
  }
}

.loginWrapper i:nth-child(1) {
  border-color: var(--clr);
  border-radius: 30% 70% 30% 70% / 70% 30% 70% 30%;
  animation: animate 4s linear infinite;
  --clr: #00ff0a;
  z-index: 1;
}

.loginWrapper i:nth-child(2) {
  border-color: var(--clr);
  border-radius: 51% 49% 30% 70% / 45% 56% 44% 55%;
  animation: animate2 6s linear infinite;
  --clr: #ff0057;
  z-index: 1;
}

.loginWrapper i:nth-child(3) {
  border-color: var(--clr);
  border-radius: 75% 25% 69% 31% / 21% 65% 35% 79%;
  animation: animate 10s linear infinite;
  --clr: #fffd44;
  z-index: 1;
}

@keyframes animate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes animate2 {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.loginCard {
  margin-top: 10vh;
  padding: 1rem;
  width: 450px;
  height: 450px;
  border: 2px solid;
  border-radius: 0.875rem;
  box-shadow: 0 8px 6px -6px black;
  z-index: 2;

  &:hover {
    border: 6px solid var(--clr);
    filter: drop-shadow(0 0 20px var(--clr));
  }
}

.loginTitle {
  margin: 0.5rem 0;
  color: #fff;
  font-size: 4.5rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 2rem;
}

/* .inputField {
  margin: 0.25rem 0;
  border: 2px solid;
  padding: 0.5rem;
  color: black;
  font-size: 1.5rem;
  text-align: center;
  margin-bottom: 1rem;
} */

.inputField {
  margin: 0.25rem 0;
  border: 2px solid;
  padding: 0.5rem;
  color: black;
  font-size: 1.5rem;
  text-align: center;
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
}

.loginBtn {
  /* background-color: #76bbe9; */
  fill: #ffffff;
  border-color: white;
  color: #ffffff;
  position: relative;
  letter-spacing: 0.5px;
  width: 50%;
  margin-top: 1rem;
  transition: transform 0.3s;
  font-size: 2rem;
  font-weight: 600;
  border-width: 4px 4px 4px 4px;
  border-style: solid;
  border-radius: 10px 0px 10px 0px;
  padding: 15px 25px 15px 25px;
  box-shadow: 5px 5px 5px 0px
    rgba(12, 11.000000000000002, 11.000000000000002, 0.77);
  background: linear-gradient(45deg, #ff357a, #fff172);
  z-index: 2;

  &:hover {
    background-color: #247a97;
    cursor: pointer;
    transform: scale(0.9);
    border-color: white;
  }
}

.signupLink {
  /* margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  color: blue;
  text-decoration: underline; */
  color: #fff;
  text-decoration: none;
  z-index: 2;

  &:hover {
    color: #fff;
    cursor: pointer;
    transform: scale(0.9);
    text-decoration: underline;
  }
}

@media screen and (max-width: 991px) {
  .loginTitle {
    font-size: 5rem;
  }
  .inputField {
    font-size: 2.25rem;
  }

  .loginBtn {
    font-size: 2rem;
  }

  .signupLink {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/Login.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,yBAAyB;;AAEzB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;;EAEhB;IACE,4BAA4B;IAC5B,wCAAwC;EAC1C;AACF;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,qCAAqC;EACrC,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,sCAAsC;EACtC,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,gDAAgD;EAChD,sCAAsC;EACtC,cAAc;EACd,UAAU;AACZ;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,UAAU;;EAEV;IACE,4BAA4B;IAC5B,wCAAwC;EAC1C;AACF;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;;;GAQG;;AAEH;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gCAAgC;EAChC,4BAA4B;EAC5B;0DACwD;EACxD,oDAAoD;EACpD,UAAU;;EAEV;IACE,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;EACrB;AACF;;AAEA;EACE;;;;+BAI6B;EAC7B,WAAW;EACX,qBAAqB;EACrB,UAAU;;EAEV;IACE,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".loginMasterWrapper {\n  background-color: #000;\n  width: 100dvw;\n  height: 100dvh;\n}\n\n.loginWrapper {\n  position: relative;\n  margin: 0 auto;\n  display: flex;\n  width: 700px;\n  height: 700px;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n/* Login Ring Animation */\n\n.loginWrapper i {\n  margin-top: 10vh;\n  position: absolute;\n  inset: 0;\n  border: 2px solid transparent;\n  border-radius: 50%;\n  transition: 0.5s;\n\n  &:hover {\n    border: 6px solid var(--clr);\n    filter: drop-shadow(0 0 20px var(--clr));\n  }\n}\n\n.loginWrapper i:nth-child(1) {\n  border-color: var(--clr);\n  border-radius: 30% 70% 30% 70% / 70% 30% 70% 30%;\n  animation: animate 4s linear infinite;\n  --clr: #00ff0a;\n  z-index: 1;\n}\n\n.loginWrapper i:nth-child(2) {\n  border-color: var(--clr);\n  border-radius: 51% 49% 30% 70% / 45% 56% 44% 55%;\n  animation: animate2 6s linear infinite;\n  --clr: #ff0057;\n  z-index: 1;\n}\n\n.loginWrapper i:nth-child(3) {\n  border-color: var(--clr);\n  border-radius: 75% 25% 69% 31% / 21% 65% 35% 79%;\n  animation: animate 10s linear infinite;\n  --clr: #fffd44;\n  z-index: 1;\n}\n\n@keyframes animate {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes animate2 {\n  0% {\n    transform: rotate(360deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n.loginCard {\n  margin-top: 10vh;\n  padding: 1rem;\n  width: 450px;\n  height: 450px;\n  border: 2px solid;\n  border-radius: 0.875rem;\n  box-shadow: 0 8px 6px -6px black;\n  z-index: 2;\n\n  &:hover {\n    border: 6px solid var(--clr);\n    filter: drop-shadow(0 0 20px var(--clr));\n  }\n}\n\n.loginTitle {\n  margin: 0.5rem 0;\n  color: #fff;\n  font-size: 4.5rem;\n  font-weight: 800;\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n/* .inputField {\n  margin: 0.25rem 0;\n  border: 2px solid;\n  padding: 0.5rem;\n  color: black;\n  font-size: 1.5rem;\n  text-align: center;\n  margin-bottom: 1rem;\n} */\n\n.inputField {\n  margin: 0.25rem 0;\n  border: 2px solid;\n  padding: 0.5rem;\n  color: black;\n  font-size: 1.5rem;\n  text-align: center;\n  margin-bottom: 1rem;\n  position: relative;\n  z-index: 1;\n}\n\n.loginBtn {\n  /* background-color: #76bbe9; */\n  fill: #ffffff;\n  border-color: white;\n  color: #ffffff;\n  position: relative;\n  letter-spacing: 0.5px;\n  width: 50%;\n  margin-top: 1rem;\n  transition: transform 0.3s;\n  font-size: 2rem;\n  font-weight: 600;\n  border-width: 4px 4px 4px 4px;\n  border-style: solid;\n  border-radius: 10px 0px 10px 0px;\n  padding: 15px 25px 15px 25px;\n  box-shadow: 5px 5px 5px 0px\n    rgba(12, 11.000000000000002, 11.000000000000002, 0.77);\n  background: linear-gradient(45deg, #ff357a, #fff172);\n  z-index: 2;\n\n  &:hover {\n    background-color: #247a97;\n    cursor: pointer;\n    transform: scale(0.9);\n    border-color: white;\n  }\n}\n\n.signupLink {\n  /* margin-top: 1rem;\n  margin-bottom: 1rem;\n  font-size: 1.5rem;\n  color: blue;\n  text-decoration: underline; */\n  color: #fff;\n  text-decoration: none;\n  z-index: 2;\n\n  &:hover {\n    color: #fff;\n    cursor: pointer;\n    transform: scale(0.9);\n    text-decoration: underline;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .loginTitle {\n    font-size: 5rem;\n  }\n  .inputField {\n    font-size: 2.25rem;\n  }\n\n  .loginBtn {\n    font-size: 2rem;\n  }\n\n  .signupLink {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
